import { GlobalStyles } from "@mui/material";

const GlobalStylesCss = () => (
  <GlobalStyles
    styles={{
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        fontFamily: 'Montserrat, sans-serif',
      },
      html: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        backgroundColor: "#f4f6f8",
        height: "100%",
        width: "100%",
      },
      a: {
        textDecoration: "none",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
    }}
  />
);

export default GlobalStylesCss;
